import React from "react";

import "./statusButton.scss";

const StatusButton = ({
  size,
  status = "primary",
  label,
  type,
  onClick,
  disabled = false,
  fullWidth = false,
  className = "",
  ...others
}) => {
  const buttonClasses = `auto-button auto-button-${size} auto-button-${status} ${disabled ? 'auto-button-disabled' : ''} ${className}`;
  const dataBlockProps = fullWidth ? { "data-block": true } : {};

  return (
    <button
      className={buttonClasses}
      type={type}
      onClick={onClick}
      disabled={disabled}
      {...dataBlockProps}
      {...others}
    >
      {label}
    </button>
  );
};

export default StatusButton;
